export * from './BaseFileInput.vue';
export { default } from './BaseFileInput.vue';
